import React from 'react'

import PrecautionModalOnline from 'src/components/Modal/PrecautionModalOnline'

const PrecautionModalPage: React.FC = () => {
  return <PrecautionModalOnline isOpen={true} />
}

export const PATH = '/precaution-modal-online' as const
export default PrecautionModalPage
